import React from 'react'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import TransactionsList from './TransactionsList'
import { Skeleton } from '@mui/material'
import UnauthorizedBlock from '../../components/UnauthorizedBlock'

interface IProps {
    itemId: number,
    loading?: boolean,
    usePublicDetails?: boolean,
    itemContained?: boolean
}

export default function ItemTransactions(props: IProps) {

    const { itemId, loading, usePublicDetails, itemContained } = props


    return(
        <SectionBoxContainer loading={loading} showTitle title="Transactions">
            {usePublicDetails ? <UnauthorizedBlock title="Unauthorized" message="You have to sign-in to your account in order to view the information." buttons={[ { label: "Sign-in", link: "/sign-in", color: "error" } ]} /> : loading ? <div style={{ padding: 35 }}><Skeleton variant="rectangular" width={"100%"} height={500} /></div> : <TransactionsList itemId={itemId} itemContained={itemContained} noSectionBoxWrap hidePageHeadSection />}
        </SectionBoxContainer>
    )
}